import { render, staticRenderFns } from "./files-gallery-modal.vue?vue&type=template&id=6c884f42&scoped=true"
import script from "./files-gallery-modal.vue?vue&type=script&lang=js"
export * from "./files-gallery-modal.vue?vue&type=script&lang=js"
import style0 from "./files-gallery-modal.vue?vue&type=style&index=0&id=6c884f42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c884f42",
  null
  
)

export default component.exports